<template>
    <s-modal title="Editer un membre"
             :save="true"
             @save="save"
             :deleteData="tournoi ? false : true"
             :close="true"
             @close="$emit('close')"
             :open="open"
             @delete="openModalDeleteJoueur()"
    >
    <div style="height: 500px;width:95%">
      
        
         
        
       <div class="tabs  is-boxed is-fullwidth is-normal">
           
           <ul>
               <li :class="onglet==0?'is-active':''">
                    <a  href="#" v-on:click="change(0)">
                            <span class="icon "><i class="fas fa-address-card" aria-hidden="true"></i></span>
                            <span class="g_menuDesktop">
                                <s-l id="membre_tab1">Information</s-l>
                            </span>
                    </a>
               </li>
               <li  :class="onglet==1?'is-active':''">
                   <a href="#" v-on:click="change(1)">
                            <span class="icon "><i class="fas fa-user-tag" aria-hidden="true"></i></span>
                            <span class="g_menuDesktop">
                             <s-l id="membre_tab2">Tag</s-l>
                             </span>
                    </a>
                </li>
                <li  :class="onglet==2?'is-active':''">
                   <a href="#" v-on:click="change(2)">
                            <span class="icon "><i class="fas fa-user-cog" aria-hidden="true"></i></span>
                             <span class="g_menuDesktop">
                                 <s-l id="membre_tab3">Rôles</s-l>
                             </span>
                    </a>
                </li>
               <li  :class="onglet==3?'is-active':''">
                   <a href="#" v-on:click="change(3)">
                            <span class="icon"><i class="fas fa-chart-bar" aria-hidden="true"></i></span>
                            <span class="g_menuDesktop">
                             <s-l id="membre_tab4">Statistique</s-l>
                            </span>
                    </a>
                </li>
            </ul>
        </div>
       
        <div v-if="onglet==0">
            <div class="label formJoueur">
               <s-l id="membre_licence"> Numéro de Licence :</s-l>
            </div>
            <s-input theme="input is-normal is-rounded is-light" width="300px"
            v-model="joueur.licence" placeholder="Numéro de licence" :mandatory="false"/>
            <br/><br/>
            <div style="padding-bottom:20px">
                <div class="label formJoueur" >
                   <s-l id="membre_nom">  Nom :</s-l>
                </div>
                <s-input maxlength="40" theme="is-normal is-light" change="true" 
                v-model="joueur.nom" placeholder="Nom" :mandatory="false" width="300px"
                id="joueurNom"
                :focus="true"
                ref="joueurNom"
                />
            
                <br/><br/> <div class="label formJoueur">
                    <s-l id="membre_prenom"> Prénom :</s-l>
                </div>
                <s-input maxlength="40" theme="is-normal  is-light" change="true" 
                v-model="joueur.prenom" placeholder="Prénom" :mandatory="false"  width="300px"/>
            </div>
            <div class="label formJoueur">
               <s-l id="membre_pseudo">  Pseudo :</s-l>
            </div>
            <s-input maxlength="10" width="300px"  
                theme="is-medium" change="true" @change="hideOrShowError()" 
                v-model="joueur.pseudo" :placeholder="pseudo" :mandatory="true"/>
            <div class="info" v-if="userData">
                <span v-show="userData.displayName != joueur.pseudo">
               <s-l id="membre_connecte"> Ce joueur est connecté à la plateforme et utilise le pseudo </s-l> {{userData.displayName}}
               
                </span>
            </div>
            
            <div class="error" v-show="error.exist">
               <s-l id="membre_errorexist"> Ce joueur existe déjà.</s-l>
            </div>
            <div class="error" v-show="error.name">
                <s-l id="membre_errornom">  Son nom est vide</s-l>
            </div>
            <div class="error" v-show="!error.exist && !error.name">
                &nbsp;
            </div>
            <div class="label formJoueur">
               <s-l id="membre_email">  Email : </s-l>&nbsp;&nbsp; </div>
            <div class="formInputJoueur">
                
                <s-input :disabled="fieldEmailEnabled"  width="300px"  theme="is-normal is-light" 
                    v-model="joueur.email"  placeholder="Email facultatif" 
                    v-if="!emailParentExist"
                    />
                <span v-if="emailParentExist">
                    {{joueur.emailParent}} <s-button label="" @onclick="deleteEmailParent()" icon="trash" theme="is-danger is-small"/>
                    <br/><i style="font-size:12px">Ce joueur est rattaché à un autre joueur</i>
                </span>
                <div style="float:right">
                <s-button  theme="is-info is-small" label="" icon="info" @onclick="infoEmail=true"/> 
                </div>
            </div>
            <s-modal
                :open="infoEmail"
                :close="true"
                @close="infoEmail=false"
                title="Pourquoi renseigner un email ?"
                >
                <div class="notification is-info" style="padding-top:5px" v-show="infoEmail">
                    <div style="width:90%;text-justify:auto">
                    <s-l id="membre_emailexplain"> Si vous renseigner l'email, un mail sera adressé à votre membre avec un lien pour se connecter au site. <br/>
                    <br/> Il pourra ainsi suivre l'évolution du tournoi et même renseigner lui même le score de ses parties <br/></s-l>
                    <br/>
                    <s-l id="membre_create_tournoi">Lors que vous allez créer un tournoi, vous allez avoir la possibilité d'envoyer un email à tous vos membres ainsi ils pourront eux mêmes s'inscire à vos tournois</s-l>
                    
                    </div>
                </div>
                <div class="notification is-warning">
                    <s-l id="membre_emailParent">Si vous renseignez un email que vous avez déjà renseigné sur un autre membre, votre joueur sera rattaché à celui-ci. Ainsi le joueur (père) pourra l'inscrire à vos tournois</s-l>
                </div>
            </s-modal>
           
            
            <span class="info" v-if="userData ? userData.login : false">
               <s-l id="membre_connecteexplain"> Utilisateur connecté ! Il est impossible de changer son email</s-l>
            </span><br/><br/>
               <label class="label formJoueur">
                <s-l id="membre_mobile">Portable :</s-l>
            </label>
            <s-input  theme="input is-normal is-rounded is-light" change="true" width="300px"
            v-model="joueur.tel" placeholder="Numéro de portable" />
          
             <br/><br/><div class="label">
             <s-l id="membre_mobile"> Adresse : </s-l>
            </div>
            <textarea v-model="joueur.adresse" cols="80" rows="2" class="textarea is-light" placeholder="Adresse">
            </textarea><br/>
            
            
        
        </div>
        <div  v-if="onglet==1">
            <div v-for="custom in clubData.customs">
                <div class="label formJoueur">
                    {{custom.label}}
                </div>
                <span v-if="custom.type!='radio' && custom.type!='checkbox'">
                    <input :name="custom.id" :type="custom.type" class="input is-light is-rounded is-normal" 
                    style="width:300px" v-model="joueur.customs[custom.id]"/>
                </span>
                <span v-if="custom.type=='radio' || custom.type=='checkbox'">
                    <label :class="custom.type" v-for="(value, index) in custom.values">
                        <input
                            :name="custom.id" 
                            :type="custom.type" :value="index" 
                            v-model="joueur.customs[custom.id]" /> 
                       
                         {{value}}
                    </label>
                </span>
            </div>
        </div>
        <div v-if="onglet==2">
            <div v-if="myRole!='owner'">
                <s-l if="roleAttributeRole">Vous n'êtes pas le gestionnaire de ce club. vous ne pouvez pas changer le rôle. Veuillez contacter le gestionnaire</s-l>
            </div>
            <s-button v-if="tournoi" theme="is-primary is-small" v-show="joueur.email!=''" 
                label="Invitation au tournoi" icon="envelope" @onclick="send" />
            <div  v-if=" userIsConnected && myRole == 'owner'">
                Peut organiser des concours :
                <s-button type="button" label="NON" 
                    @onclick="setAdmin(false)" :theme="!joueur.admin ? 'is-success is-small' : 'is-black  is-small'"/>
                &nbsp;
                <s-button type="button" label="OUI" 
                    @onclick="setAdmin(true)" :theme="joueur.admin ? 'is-success  is-small' : 'is-black  is-small'"/>
            </div>
            <div v-if="joueur.userId!=owner">
                <div v-if="userIsConnected && joueur.admin && !clubIsSubscription()">
                Ce membre est donc ORGANISATEUR !<br/>
                    <b> ATTENTION : Ce club ne possède pas d'abonnement !</b><br/>
                Ce membre ne pourra pas CREER de concours, seul le GESTIONNAIRE peut les créer. <br/>
                Il pourra cependant accèder aux concours existant et les organiser. 
                </div>
                <div v-if="userIsConnected && joueur.admin && clubIsSubscription()">
                Ce membre est donc ORGANISATEUR !<br/>
                Le club possède un abonnement !<br/>
                Ce membre pourra créer des concours
                </div>
            </div>
            <div  v-show="!userIsConnected && myRole=='owner'">
               Ce membre n'est pas connecté. vous ne pouvez pas lui attribuer un rôle d'ORGANISATEUR<br/>
               Pour qu'il puisse se connecter à petanque-app.com, il faut lui atribuer un email et qu'il se connecte à l'application
            </div>
             <div v-show="joueur.userId==owner">
                Ce membre est le GESTIONNAIRE du club !<br/>
                IL N Y A QU UN SEUL GESTIONNAIRE PAR CLUB. <br/>LE GESTIONNAIRE A TOUS LES DROITS.

            </div>
            <div>
            <div v-if="myRole=='owner' && userIsConnected && joueur.userId!=owner && joueur.admin" style="margin-top: 50px;text-align:center">
                <s-button icon="user-tie" 
                        theme="is-warning is-normal" 
                        @onclick="modalChangeProprietaire=true" 
                        label="Mettre ce joueur en tant que GESTIONNAIRE"/>
                <div style="margin:10px">
                    IL N Y A QU UN SEUL GESTIONNAIRE PAR CLUB. <br/>LE GESTIONNAIRE A TOUS LES DROITS.
                </div>
            </div>
            <s-confirm
                :open="modalChangeProprietaire"
                @yes="changeProprietaire"
                @no="modalChangeProprietaire=false"
            >
                Vous êtes sur le point de changer le GESTIONNAIRE du club.<br/>
                Vous ne serez plus le GESTIONNAIRE du club<br/>
                 IL N Y A QU UN SEUL GESTIONNAIRE PAR CLUB. <br/>LE GESTIONNAIRE A TOUS LES DROITS.<br/>
                Vous basculerez en tant que ORGANISATEUR de concours<br/><br/>
                <b>Souhaitez vous continuer ?</b><br/>
                <i>(Si vous dites OUI, vous ne pourrez plus modifier les rôles, seul le GESTIONNAIRE peut le faire)</i>
            </s-confirm>    
            </div>
        </div>
        <div v-if="onglet==3">
            <s-elo :elo="elo"/>
            <div style="width:90%">
                <profil-item :joueur="joueur" :club="clubData.name"/>
            </div>
        </div>
    </div>
     <s-confirm 
        :open="modalDeleteJoueur"
        @yes="deleteJoueur()"
        @no="modalDeleteJoueur=false">
           
           <div class="">
               <s-l id="modal_confirm_supprimer_joueur" :v="joueur.nom + ' '+joueur.prenom">Souhaitez réellement supprimer le joueur %v  ?</s-l>
           </div>
            
    </s-confirm>
    </s-modal>       

</template>
<style  scoped>
    
    ::placeholder {
        color: rgb(124, 120, 120);
        font-size:20px;
    }
    .formJoueurADMIN  {
        width:300px;
        display:inline-block;
        vertical-align: middle;
    }

    .formJoueur {
        width:170px;
        display:inline-block;
        vertical-align: middle;
        
    }
    .formInputJoueur {
        width:350px;
        display:inline-block;
    }
    .error {
        font-size: 12px;
        font-style: italic;
        color: rgb(206, 50, 50);
        margin-top: 5px;
        margin-bottom: 5px;
        height: 20px;
        margin-left: 170px;
    }
    .info {
        font-style: italic;
        font-size: 14px;
        padding-left: 20px;
    }
   
     input[type=radio] {
        
        margin-left: 20px;
    }input[type=checkbox] {
        
        margin-left: 20px;
    }
   
    
    .anonyme {
        
        width: 200px;
        padding: 5px;
        margin-bottom: 10px;
        float:left;
    }
</style>
<script>
import user from "@/firebase/user";
import profilItem from "@/views/profil/profilItem";
import club_fct from "@/firebase/club"
import joueur_fct from "@/firebase/joueur"
import firebase_api from "@/firebase/firebase_api"
export default {
    props: ["open","joueurs", "clubData", 'joueur', 'tournoi','owner'],
    components: {
        profilItem
    },
    data() {
        return {
            error: {
                exist: false,
                email: false,
                name: false
            },
            infoEmail: false,
            userData: null,
            onglet: 0,
            values: null,
            modalChangeProprietaire: false,
            modalDeleteJoueur: false
        }
    },
    watch: {
        open(val) {
            if (val) {
                this.refresh();
                
                if (typeof(this.$refs["joueurNom"])!="undefined")
                    this.$refs["joueurNom"].focusInput();

            }
        }
    },
    computed: {
        emailParentExist: {
            get() {
                var bool = false;
                if (typeof(this.joueur.emailParent)!="undefined")
                    if (this.joueur.emailParent!= '')
                        bool = true;
                return bool;
            }
        },
        fieldEmailEnabled: {
            get() {
                return this.userData ? this.userData.login : false
            }
        },
        userIsConnected : {
            get() {
                var returnConnected = false;
                if (this.userData==null)
                    returnConnected =  false;
                else
                    returnConnected = this.userData.login;
                return returnConnected;
            }
            
        },
        myRole: {
            get() {
                return this.$getRole(this.clubData, this.$store.getters.getUser)
            }
        },
        role: {
            get() {
                return this.joueur.role == "owner"
            }
        },
        pseudo: {
            get() {
                return this.calculPseudo();
            }
        },
        
        elo : {
            get() {
                
               return typeof(this.joueur.elo) == "undefined" ? 1199 : this.joueur.elo
            }
        }      
    },
    mounted() {
        this.refresh();
    },
    methods: {
        setAdmin(admin) {
            this.joueur.admin = admin;
            this.save(false);
        },
        clubIsSubscription() {
            if (this.clubData!=null) {
            if (typeof(this.clubData.subscription) != "undefined")
                    if (this.clubData.subscription.status == "active") {
                        var date = new Date();
                        var endDate = this.clubData.subscription.period_end.toDate();
                        var startDate =  this.clubData.subscription.period_start.toDate();
                        endDate.setDate(endDate.getDate() + 7);
                        
                        if (startDate < date && date < endDate)
                            return true;
                        else
                            return false;
                    }
                    else
                        return false;
                else
                    false;
            }
            else
                return false;
        },
        deleteEmailParent() {
            firebase_api.api.getDb().collection("club").doc(this.clubData.id).collection("joueurs")
                .where("email","==",this.joueur.emailParent).get().then(docs=>{
                    docs.forEach(doc=>{
                        var joueurParent = doc.data();
                        var indexChild = joueurParent.children.findIndex(elt=>elt === this.joueur.id);
                        joueurParent.children.splice(indexChild, 1);
                        doc.ref.update({
                            children: joueurParent.children
                        })
                    })
                })
            this.joueur.emailParent = "";
            this.joueur.userId = null;
            this.save();
        },
        refresh() {
        if (this.joueur.id==null) {
            var customs = {};
            for (var custom in this.clubData.customs) {
                var customJson = this.clubData.customs[custom]
                if (customJson.type=="checkbox" && customJson.valuesDefault==null)
                    customs[customJson.id] = [];
                if (typeof(customJson.valuesDefault)!="undefined")
                    customs[customJson.id] = customJson.valuesDefault;
                else
                    customs[customJson.id] = null;
                
            }
            
            this.joueur.customs = customs;
        }
        this.joueur.idClub = this.clubData.id;
        
       
        if (this.joueur.userId != null)
            user.object.getById(this.joueur.userId, userData=>{
                this.userData = userData;
        })
        else {
            this.userData = null;
            this.onglet=0;
        } 
       
     },
     
        deleteJoueur() {
            joueur_fct.object.delete(this.clubData, this.joueur, ()=>{
                 this.$emit('close');
                 this.modalDeleteJoueur = false;
            })
        },
         openModalDeleteJoueur() {
            this.modalDeleteJoueur = true;
        },
        async changeProprietaire() {
            await club_fct.object.changeProprietaire(this.clubData, this.$store.getters.getUser, this.joueur, (bool)=>{
                this.modalChangeProprietaire = false;
                if (bool) {
                  this.$store.dispatch("init", ()=>{
                    location.reload();
                  })
                }
            });
        },
        enabledAdmin() {
            var enabled = false
          
            if (this.joueur.userId!=null)
                if (this.userData!=null)
                    enabled = this.userData.login;
            return !enabled;
        },
        setCustomsValues(id) {
            this.joueur.customs[id] = this.values;
        },
        calculPseudo() {
            var pseudo = "";
           if (typeof(this.joueur.pseudo) == 'undefined' || this.joueur.pseudo =='') {
              if (this.joueur.nom!='') {
              pseudo = this.joueur.nom.substr(0,7).toUpperCase();
              if (this.joueur.prenom!='')
                  pseudo += "." + this.joueur.prenom.substr(0,3).toUpperCase();
              else
                   pseudo += this.joueur.nom.substr(8,3).toUpperCase();
              }
              else {
                  if (this.joueur.prenom!='')
                    pseudo += this.joueur.prenom.substr(0,8).toUpperCase();
                  else 
                    pseudo = "PSEUDO DU JOUEUR"
              }
          }
          return pseudo;
        },
        change(onglet) {
            this.onglet = onglet;
        },
        deleteguate () {
            if (this.role)
                this.joueur.role = "player"
            else
                 this.joueur.role = "owner"
        },
         hideOrShowError() {
            if (typeof(this.joueur)!="undefined") {
                this.error.name = (this.joueur.pseudo == "");
                if (!this.error.name) {
                    var indexJoueur = this.joueurs.findIndex(elt=>elt.pseudo.trim().toUpperCase() === this.joueur.pseudo.trim().toUpperCase());
                    if (indexJoueur == -1)
                        this.error.exist = false;
                    else {
                        this.error.exist = this.joueurs[indexJoueur].id != this.joueur.id;
                    }
                        
                } 
            }
        },
         send(){

        },
        save(close) {
            var windowClose = true;
            if (typeof(close)!="undefined")
                windowClose = close;
            delete this.joueur.invite;
            this.joueur.pseudo = joueur_fct.object.calculPseudo(this.joueur)
            if (this.joueur.pseudo != "") {      
                
                var indexJoueur = this.joueurs.findIndex(elt=>elt.pseudo.trim().toUpperCase() === this.joueur.pseudo.trim().toUpperCase());
                var maj = false,
                
                // Si on a pas aucun joueur n'a comme pseudo le nouveeau joueur alors on peut ajouter le joueur
                maj = indexJoueur == -1 && this.joueur.id == null;

                if (!maj) {
                    // Si on veut mettre à jour le joueur, et que le pseudo n'est pas utilisé alors c bon on peut modifier le joueur
                    maj = this.joueur.id != null && indexJoueur == -1
                }
                if (!maj) {
                    // si on veut mettre à jour mais que le pseudo appartient à un joueur, on vérifie que c'est bien le même joueur
                    // sinon on ne permet la mise à jour (le flag du être mis)
                    if (indexJoueur != -1 && this.joueur.id != null) 
                        maj = this.joueurs[indexJoueur].id == this.joueur.id;
                }
                if (maj) {
                        if (windowClose)
                            this.$emit('close');
                        var batch = firebase_api.api.getDb().batch();
                        club_fct.object.addJoueur(this.clubData, this.joueur, batch, null, (error)=>{
                            
                            batch.commit();
                            if (this.clubData.demo) {
                                this.clubData.tuto = 2;
                                club_fct.object.setTuto(this.clubData);
                            }
                            if (typeof(error.error) != "undefined") {
                                if (error.error=="EMAILEXIST")
                                    this.error.email=true;
                            }
                        })
                     
                }
                this.$emit("saved", this.joueur);
            }
        }
    }
}
</script>